import React from "react";
import { Pencil } from "lucide-react";
import { Button } from "./ui/button";
import WeighmentSlipActions from "./WeighmentSlipActions";

export default function WeighmentReceiptActions({
  purchaseId,
  label,
  compact = false,
  onEdit,
  canEdit = false,
}) {
  const safeLabel = (label || `purchase-${purchaseId}`).replace(/[/\\?%*:|"<>]/g, "-");

  const docActions = (
    <WeighmentSlipActions
      printPath={`/purchases/${purchaseId}/weighment-receipt/print`}
      pdfPath={`/purchases/${purchaseId}/weighment-receipt/pdf`}
      pdfFilenameBase={`weighment-${safeLabel}`}
      opsKind="unloading"
      compact={compact}
      testIdPrefix={`weighment-${purchaseId}`}
      stopPropagation={compact}
    />
  );

  if (compact) {
    return (
      <div className="flex items-center justify-end gap-0.5" onClick={(e) => e.stopPropagation()}>
        {docActions}
        {canEdit && onEdit && (
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-8 w-8 shrink-0 text-muted-foreground hover:text-foreground"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            title="Edit weights"
            aria-label="Edit weights"
            data-testid={`edit-weighment-${purchaseId}`}
          >
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </div>
    );
  }

  return <div className="flex flex-wrap items-center gap-2 shrink-0">{docActions}</div>;
}
